import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { auth, db } from "./firebase/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import Login from "./Login";
import TherapistDashboard from "./TherapistDashboard";
import AthleteDashboard from "./AthleteDashboard";
import CoachDashboard from "./CoachDashboard";
import AdminDashboard from "./AdminDashboard";
import NutritionistDashboard from "./NutritionistDashboard";
import { BannerProvider } from "./components/BannerContext";
import Banner from "./components/Banner";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userDoc = await getDoc(doc(db, "users", firebaseUser.uid));
        const userData = userDoc.exists() ? userDoc.data() : {};

        setUser({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          name: userData.name || firebaseUser.email,
          role: userData.role,
          club: userData.club || null,
        });

      } else {
        setUser(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>; // you can replace with a spinner later
  }

  const isNativeAndroid = typeof window !== "undefined" && window.Capacitor?.getPlatform?.() === "android";

  return (
    <BannerProvider>
      <Router>
        {/* Spacer for Android app to prevent content from overlapping status bar */}
        {isNativeAndroid && (
          <div style={{ height: "32px", backgroundColor: "#f1efe7" }}></div>
        )}

        {/* ✅ This shows banner messages on all routes */}
        <div className="px-4 pt-2 max-w-2xl mx-auto">
          <Banner />
        </div>

        <Routes>
          <Route path="/" element={<Login setUser={setUser} />} />
          <Route path="/therapist-dashboard" element={user?.role === "therapist" ? <TherapistDashboard user={user} /> : <Login setUser={setUser} />} />
          <Route
            path="/athlete-dashboard"
            element={["athlete", "client"].includes(user?.role) ? (
              <AthleteDashboard user={user} />
            ) : (
              <Login setUser={setUser} />
            )}
          />
          <Route path="/coach-dashboard" element={user?.role === "coach" ? <CoachDashboard user={user} /> : <Login setUser={setUser} />} />
          <Route path="/nutritionist-dashboard" element={user?.role === "nutritionist" ? <NutritionistDashboard user={user} /> : <Login setUser={setUser} />} />
          <Route path="/admin" element={user?.role === "admin" ? <AdminDashboard user={user} /> : <Navigate to="/" />} />
        </Routes>
      </Router>
    </BannerProvider>
  );
}


export default App;
